<template>
  <div class="page">
    <div class="container">
      <div class="page__row page__companies">
        <div class="page__inner">
          <p class="page__counter">01</p>
          <h1 class="subtitle subtitle_red page__subtitle" style="top: -22px">Conduct campaigns nationwide</h1>
        </div>
        <div class="page__grid">
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">02</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Establish effective dialogue between the government, business, and society</h1>
          </div>
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">03</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Develop an ecosystem of partnership when solving problems</h1>
          </div>
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">05</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Anti-crisis support, addressing complex communication cases</h1>
          </div>
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">04</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Design and production of narratives and events</h1>
          </div>
        </div>
      </div>
    </div>

    <companies-background />

    <page-footer :next="{ name: 'dialog-en' }" />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import CompaniesBackground from '@/components/servicesSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '@/views/mixins/route'

export default {
  name: 'companies-en',
  mixins: [RouteMixin],
  components: {
    CompaniesBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.companies-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__counter', 0.3, { y: '-20px', opacity: 0 }))
      .add(TweenMax.from('.page__subtitle', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__subtitle', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__counter', 0.3, { y: '20px', opacity: 0 }))
      .add(TweenMax.to('.companies-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
